import { styleTags, tags as t } from '@lezer/highlight';

export const httpHighlighting = styleTags({
  Method: t.keyword,
  HttpVersion: t.meta,
  StatusText: t.string,
  statusTextContent: t.string,
  Url: t.url,
  urlContent: t.url,

  HeaderName: t.propertyName,
  AuthorizationHeaderName: t.propertyName,
  CookieHeaderName: t.propertyName,

  // HeaderValue, headerValueContent, StatusCode, and all cookie/auth
  // value tokens (CookieKey, CookieVal, AuthType, AuthToken, etc.)
  // are intentionally NOT mapped here. Their coloring is handled
  // entirely by ViewPlugin decorators (header-value-decorator.ts,
  // status-code-decorator.ts) which provide content-aware highlighting
  // that the grammar's flat tokens can't support. The Lezer compiler
  // also inlines the cookie/auth value tokens, making styleTags
  // entries for them ineffective.

  BodyText: t.content,
  bodyContent: t.content,
});
